uic-icon {
  color: inherit;
  display: inline-block;
  fill: currentColor;

  height: var(--uic-icon-height);
  pointer-events: none;
  width: var(--uic-icon-width);

  &[size='small'] {
    --uic-icon-height: var(--uic-icon-dimensions-default);
    --uic-icon-width: var(--uic-icon-dimensions-default);
  }

  svg {
    height: 100%;
    width: 100%;
  }
}
